import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';

import {
  TemplateEvaluationError,
  TemplateExpression,
  TemplateInterpolator,
} from '@fmnts/declarative-forms';

/**
 * Template interpolator for date related expressions.
 *
 * Supports:
 *  - `date:now:iso` -> Current date in ISO format
 *  - `date:now:string` -> Current date in string format
 */
@Injectable()
export class DateTemplateService implements TemplateInterpolator {
  canCreate(expression: TemplateExpression): boolean {
    return expression.expression.startsWith('date:');
  }

  expression$(expression: TemplateExpression): Observable<string> {
    return this.date$(expression);
  }

  private date$(templateExpression: TemplateExpression): Observable<string> {
    const { expression } = templateExpression;
    const now = new Date();

    switch (expression) {
      case 'date:now:iso':
        return of(now.toISOString());
      case 'date:now:string':
        return of(now.toDateString());
      default:
        return throwError(
          () =>
            new TemplateEvaluationError(
              templateExpression,
              `Unknown date expression ${expression}`,
            ),
        );
    }
  }
}
